import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  output,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { SharedService } from '../../_services/shared.service';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-modal',
  imports: [TranslateModule],
  templateUrl: './modal.component.html',
  standalone: true,
  styleUrl: './modal.component.css',
})
export class ModalComponent implements OnInit, OnDestroy {
  close = output<void>();

  @ViewChild('form', { read: ViewContainerRef, static: true })
  form!: ViewContainerRef;
  private titleSubscription?: Subscription;
  private formSubscription?: Subscription;
  private labelSubscription?: Subscription;
  private ignoreNextClickInModalOpen = true;

  label?: string;

  constructor(
    private elementRef: ElementRef,
    private sharedService: SharedService,
  ) {}

  ngOnInit() {
    this.labelSubscription = this.sharedService.currentLabel$.subscribe(
      (label: string | null) => {
        if (label) {
          this.label = label;
        }
      },
    );
    this.formSubscription = this.sharedService.currentForm$.subscribe(
      (
        formData: {
          formRef: Type<any>;
          isTeam?: boolean;
        } | null,
      ) => {
        if (formData) {
          this.loadComponent(formData);
        }
      },
    );
    this.sharedService.isModalOpen$.subscribe((isVisible) => {
      if (!isVisible) this.ignoreNextClickInModalOpen = true;
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.ignoreNextClickInModalOpen) {
      this.ignoreNextClickInModalOpen = false;
      return;
    }

    // Is one of these false, it should not close the modal
    if (
      !this.elementRef.nativeElement.contains(event.target) &&
      // Angular Material attaches some Elements (like DropDown Choices) to the body element within
      // a overlay-container, usually classified with .cdk-overlay-container
      !document
        .querySelector('.cdk-overlay-container')
        ?.contains(event.target as Node) &&
      !this.isDescendantOfClass(
        event.target as Element,
        'form-footer-nav-button',
      )
    ) {
      this.ignoreNextClickInModalOpen = true;
      this.close.emit();
    }
  }

  closeModal() {
    this.ignoreNextClickInModalOpen = true;
    this.close.emit();
  }

  loadComponent(formData: { formRef: Type<any>; isTeam?: boolean }) {
    this.form.clear();
    let cmpRef = this.form.createComponent(formData.formRef);

    // The RIS Form is dynamic depending on Resource-Type
    // Important for the validation Service (mailNickname or siteName)
    if (formData.isTeam) cmpRef.instance.isTeam = formData.isTeam;
  }

  ngOnDestroy() {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
    if (this.titleSubscription) {
      this.titleSubscription.unsubscribe();
    }
    if (this.labelSubscription) {
      this.labelSubscription.unsubscribe();
    }
  }

  private isDescendantOfClass(
    element: Element | null,
    className: string,
  ): boolean {
    while (element) {
      if (element.classList && element.classList.contains(className))
        return true;
      element = element.parentElement;
    }

    return false;
  }
}
